var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-input",
    {
      staticClass: "NumberPoint",
      style: _vm.customStyle,
      attrs: {
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        size: _vm.size,
        clearable: _vm.clearable,
        maxlength: _vm.maxlength,
        minlength: _vm.minlength,
      },
      on: {
        input: _vm.onInput,
        blur: _vm.blur,
        focus: _vm.focus,
        change: _vm.change,
        clear: _vm.clear,
      },
      model: {
        value: _vm.value,
        callback: function ($$v) {
          _vm.value = $$v
        },
        expression: "value",
      },
    },
    [
      _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2),
      _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2),
      _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2),
      _c("template", { slot: "append" }, [_vm._t("append")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }